import { z } from 'zod'

const TypeConflictSchema = z.object({
  vin: z.string(),
  type_id: z.number().int(),
  display_name: z.string(),
})

const VehicleDetailsSchema = z.object({
  id: z.number().int(),
  subject_id: z.number(),
  subject_type: z.string(),
  color: z.string(),
  verified: z.boolean(),
  vin: z.string().nullable(),
  license_plate: z.string().nullable(),
  license_plate_state: z.string().nullable(),
  display_name: z.string().nullable(),
  legacy_vehicle_id: z.number().nullable(),
  soft_deleted: z.boolean(),
})

const VehicleSpecsSchema = z.object({
  year: z.number().nullable(),
  make: z.string().nullable(),
  model: z.string().nullable(),
  category: z.string().nullable(),
  category_v2: z.string().nullable().optional(),
})

const VehicleInsuranceSchema = z.object({
  expiration_date: z.string().nullable().optional(),
  status: z.string().nullable().optional(),
  s3_url: z.string().nullable().optional(),
  verified_first_name: z.boolean().nullable().optional(),
  verified_last_name: z.boolean().nullable().optional(),
})
const VehiclePlateLookupSchema = z.object({
  vin: z.string().nullable().optional(),
  result: z.enum(['success', 'failure', 'not_attempted', 'in_conflict', 'pending']).nullable().optional(),
  failure_reason: z.string().nullable().optional(),
  display_name: z.string().nullable().optional(),
})

export const VehicleResponseSchema = z.object({
  details: VehicleDetailsSchema,
  specs: VehicleSpecsSchema,
  insurance: VehicleInsuranceSchema.nullable().optional(),
  certifications: z.array(z.string()),
  selected_as_active: z.boolean().nullable().optional(),
  plate_lookup: VehiclePlateLookupSchema.nullable().optional(),
  vin_conflicts: z.array(TypeConflictSchema).nullable().optional(),
})

export const GetVehiclesResponseSchema = z.array(VehicleResponseSchema)

export type VehicleResponse = z.infer<typeof VehicleResponseSchema>
export type GetVehiclesResponse = z.infer<typeof GetVehiclesResponseSchema>
